export default "__VITE_ASSET__KVRBRRy___"